// extracted by mini-css-extract-plugin
export default {"image":"JeAsBF0b","src":"sX8xPdQU","blurred_preview":"AOLQTJk7","cover":"BGY22OZu","contain":"KWDFnyRF","imgCanBeShowed":"B_gmuQWX"};